module.exports = __webpack_public_path__ + "img/solutions-ch2-equal-rights.65cbc5c4.svg";